import './Footer.scss'
function Footer() {
    return (
        <div className="main_footer">
            <div className="footer">
                <div className="footer_item">Hotline: 0343.986.324</div>
                <div className="footer_item">
                    Email: taoonestore@gmail.com
                </div>
                <div className="footer_item">
                    Địa chỉ: Thanh Xuân - HN
                </div>
            </div>
        </div>
    );
}

export default Footer;
